/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { createContext, useContext } from "react";
import { DEFAULT_PREVIEW_RESOLUTION_ID, TPreviewResolutionId } from "./previewResolutions";
import { noop } from "@adapptio/lib-shared";
import { MEDIA_RESOLUTIONS_default, MEDIA_RESOLUTIONS_string } from "@adapptio/lib-blueprint";

export interface IPreviewResolutionContext {
	mediaResolutionId: MEDIA_RESOLUTIONS_string;
	previewResolutionId: TPreviewResolutionId;
	previewWidth: number;
	previewScale: number;
	manualWidth: number | null;
	safeAreaActive: boolean;
	setPreviewResolutionId: (previewResolutionId: TPreviewResolutionId) => void;
	setPreviewWidth: (previewWidth: number) => void;
	setManualWidth: (previewWidth: number) => void;
	setPreviewScale: (previewScale: number) => void;
	toggleSafeArea: () => void;
}

const defaultValue: IPreviewResolutionContext = {
	mediaResolutionId: MEDIA_RESOLUTIONS_default,
	previewResolutionId: DEFAULT_PREVIEW_RESOLUTION_ID,
	previewWidth: 0,
	previewScale: 100,
	manualWidth: 0,
	safeAreaActive: true,
	setPreviewResolutionId: noop,
	setPreviewWidth: noop,
	setManualWidth: noop,
	setPreviewScale: noop,
	toggleSafeArea: noop
};

export const PreviewResolutionContext = createContext<IPreviewResolutionContext>(defaultValue);

export function usePreviewResolutionContext(): IPreviewResolutionContext {
	return useContext(PreviewResolutionContext);
}
